import React, { useEffect, useState } from 'react'
import { useInfo } from '../../context/useInfo';
import { useLoaderData, useSearchParams } from 'react-router';
import ArticleEditor, { ArticleData } from '../../components/ArticleEditor';
import LoadingPage from '../../components/LoadingPage';
import utils from '../../utils';
import { useEnvironment } from '../../context/useEnv';

function DashboardCreateArticle() {
  const { isClient } = useEnvironment();

  const { info, fetchWeb } = useInfo();
  if (info == null) return <></>

  const [params, _setParams] = useSearchParams();
  const { tags: serverTags } = useLoaderData();
  const [loaded, setLoaded] = useState(false);
  const [clientTags, setTags] = useState(serverTags);

  const [baseArticle, setBaseArticle] = useState<ArticleData | undefined>(undefined);

  async function refetchData() {
    if (serverTags == undefined) {
      const response = await fetchWeb(`/wiki/categories`)
      setTags(response)
    }
    setLoaded(true)
  }

  useEffect(() => {
    if (params.has('autosave')) {
      const autosaves = utils.parseStringJSON(localStorage.getItem("wiki-autosaves") || "null") || []
      setBaseArticle(autosaves[parseInt(params.get('autosave') || '')])
    }
    refetchData()
  }, [])

  if (serverTags == null && loaded == false) return <LoadingPage />
  const tags = (serverTags || clientTags)

  async function postArticle(article: ArticleData, publish: boolean = false) {
    const response = await fetchWeb('/wiki/articles', {
      method: "POST",
      data: {
        url: article.path,
        title: article.title,
        content: article.content,
        publish
      }
    })
    return response
  }

  return <ArticleEditor
    onSubmit={postArticle}
    availableTags={tags}
    baseArticle={baseArticle}
  />
}

export default DashboardCreateArticle